import ExpandButton from './ExpandButton';
import ExpandButtonContainer from './ExpandButton.container';

export default ExpandButtonContainer(ExpandButton);
